module.exports = __webpack_public_path__ + "static/media/googleLogo.6377fdd7.png";